function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainerReefer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 11a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V11zm16 0H8v10h15V11z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 20v-8h1v8h-1z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.714 18.434l-6.928-4 .5-.866 6.928 4-.5.866z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.786 17.566l6.928-4 .5.866-6.928 4-.5-.866z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerReefer);
export default __webpack_public_path__ + "static/media/container-reefer.1d38978c8323afd2dd8ff9d45bac1544.svg";
export { ForwardRef as ReactComponent };